// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a0a01349","239":"236181b9","371":"a0f5cc72","453":"9fc2650b","455":"e4bf8511"}[chunkId] + ".chunk.js";
};